import { useEffect } from "react";

const SITE_NAME = "株式会社JAPANPACIFICDIVERS";

export function usePageTitle(pageTitle?: string) {
  useEffect(() => {
    if (pageTitle) {
      document.title = `${pageTitle} | ${SITE_NAME}`;
    } else {
      document.title = `${SITE_NAME} | 水中工事・港湾工事のプロフェッショナル`;
    }
    return () => {
      document.title = `${SITE_NAME} | 水中工事・港湾工事のプロフェッショナル`;
    };
  }, [pageTitle]);
}
